/*******************************************************************************
    plik  : frontend/src/App.tsx
    autor : Michal Kolodziejski (2:480/112.10)
    data  : 2025.01.06
    copyright  : PTODT <https://ptodt.org.pl>

    opis  : Main application component with routing

    licencja : MIT
*******************************************************************************/

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UploadPage from './pages/UploadPage';
import ProgressPage from './pages/ProgressPage';
import SuccessPage from './pages/SuccessPage';
import Footer from './components/Footer';

/**
 * @brief Main application component
 * @note WCAG and GDPR widgets are provided by CookieYes (loaded in index.html)
 * @return Application JSX structure
 */
const App: React.FC = () => {
    return (
        <div className="app">
            <a href="#main-content" className="skip-link">
                Przejdź do głównej treści
            </a>

            <main id="main-content" className="main-content" role="main">
                <Routes>
                    <Route path="/" element={<UploadPage />} />
                    <Route path="/progress/:jobId" element={<ProgressPage />} />
                    <Route path="/success/:jobId" element={<SuccessPage />} />
                </Routes>
            </main>

            <Footer />
        </div>
    );
};

export default App;
